import React from 'react';
import { CircleCheck, Bookmark, PlayCircle } from 'lucide-react';
import { useLang, tx } from '../../i18n/LanguageContext';
import { SIM_CTA_LAPTOP, SIM_CTA_PLC } from './simUtils';

export const SimExtras = ({ onStart }) => {
  const { lang } = useLang();
  const L = (ar, en) => tx(lang, ar, en);
  const points = [
    L('فهم طريقة عمل الأجهزة في الصناعة', 'Understand how industrial devices work'),
    L('تجربة الدوائر وبرامج التحكم بشكل آمن', 'Try circuits and control programs safely'),
    L('اكتساب مهارات عملية خطوة بخطوة', 'Gain practical skills step by step'),
  ];
  return (
    <section data-testid="sims-extras" className="grid lg:grid-cols-2 gap-5 mt-14">
      <div data-testid="sims-start-card" className="relative overflow-hidden rounded-3xl border border-blue-100 bg-gradient-to-br from-blue-50 to-sky-50 p-6 sm:p-8 flex flex-col sm:flex-row items-center gap-6">
        <div className="flex-1 text-center sm:text-start">
          <h3 className="text-xl sm:text-2xl font-black text-slate-900 mb-2">{L('ابدأ التعلم الآن', 'Start learning now')}</h3>
          <p className="text-slate-600 text-sm sm:text-base leading-relaxed mb-5">{L('استكشف مجموعة كبيرة من المحاكاة التفاعلية وسرّع فهمك للأنظمة الصناعية.', 'Explore a wide range of interactive simulations and speed up your understanding of industrial systems.')}</p>
          <button type="button" data-testid="sims-start-first-btn" onClick={onStart} className="btn-subscribe h-12 px-6">
            <PlayCircle className="w-5 h-5" />{L('ابدأ أول محاكاة الآن', 'Start your first simulation')}
          </button>
        </div>
        <img src={SIM_CTA_LAPTOP} alt="" className="w-56 sm:w-64 shrink-0 rounded-2xl mix-blend-multiply" />
      </div>
      <div data-testid="sims-learn-card" className="relative overflow-hidden rounded-3xl border border-slate-200 bg-white p-6 sm:p-8 flex flex-col sm:flex-row items-center gap-6">
        <Bookmark className="absolute top-5 end-5 w-6 h-6 text-blue-600" />
        <div className="flex-1">
          <h3 className="text-xl sm:text-2xl font-black text-slate-900 mb-4">{L('ماذا ستتعلم من المحاكاة؟', 'What will you learn?')}</h3>
          <ul className="space-y-3">
            {points.map(p => (
              <li key={p} className="flex items-center gap-2.5 text-slate-700 text-sm sm:text-base"><CircleCheck className="w-5 h-5 text-emerald-500 shrink-0" />{p}</li>
            ))}
          </ul>
        </div>
        <img src={SIM_CTA_PLC} alt="" className="w-40 sm:w-44 shrink-0 rounded-2xl mix-blend-multiply" />
      </div>
    </section>
  );
};
